import qs from "qs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { RouteChildrenProps } from "react-router";
import { EcapReportGroupEnum, ReportTypeEnum } from "../../../../constants/constants";
import { ROUTE_PATHS } from "../../../../constants/url-config";
import { setTitle } from "../../../../redux/actions/header.action";
import i18n from "../../../../utils/i18n";
import UTIL from "../../../../utils/utils";
import { StatisticIcon } from "../../../atoms/icon";
import AppMainCard, { MainCardProp } from "../../../atoms/main-card";


const Pillar1_Items: MainCardProp[] = [
    {
        index: 1,
        name: i18n.t("EcapModule.lbCreditRisk"),
        icon: <StatisticIcon />,
        link: `${ROUTE_PATHS.ECAPReports}?type=${ReportTypeEnum.CreditRisk}&group=${EcapReportGroupEnum.Pillar1}`
    },
    {
        index: 2,
        name: i18n.t("EcapModule.lbMarketRisk"),
        icon: <StatisticIcon />,
        link: `${ROUTE_PATHS.ECAPReports}?type=${ReportTypeEnum.MarketRisk}&group=${EcapReportGroupEnum.Pillar1}`
    },
    {
        index: 3,
        name: i18n.t("EcapModule.lbOperationalRisk"),
        icon: <StatisticIcon />,
        link: `${ROUTE_PATHS.ECAPReports}?type=${ReportTypeEnum.OperationalRisk}&group=${EcapReportGroupEnum.Pillar1}`
    }
]

const Pillar2_Items: MainCardProp[] = [
    {
        index: 1,
        name: i18n.t("EcapModule.lbBusinessRisk"),
        icon: <StatisticIcon />,
        link: `${ROUTE_PATHS.ECAPReports}?type=${ReportTypeEnum.BusinessRisk}&group=${EcapReportGroupEnum.Pillar2}`
    },
    {
        index: 2,
        name: i18n.t("EcapModule.lbConcentrationRisk"),
        icon: <StatisticIcon />,
        link: `${ROUTE_PATHS.ECAPReports}?type=${ReportTypeEnum.ConcentrationRisk}&group=${EcapReportGroupEnum.Pillar2}`
    },
    {
        index: 3,
        name: i18n.t("EcapModule.lbInterestRateRisk"),
        icon: <StatisticIcon />,
        link: `${ROUTE_PATHS.ECAPReports}?type=${ReportTypeEnum.InterestRateRisk}&group=${EcapReportGroupEnum.Pillar2}`
    }
]

interface Props extends RouteChildrenProps { }

const EcapModuleReportGroup = (props: Props) => {
    const dispatch = useDispatch();
    const [items, setItems] = useState<MainCardProp[]>([]);

    useEffect(() => {
        const query = qs.parse(props.location.search, { ignoreQueryPrefix: true });
        const group = Number(query.group);
        dispatch(setTitle(UTIL.getECapReportGroupDisplay(group)));
        switch (group) {
            case EcapReportGroupEnum.Pillar1:
                setItems(Pillar1_Items);
                break;
            case EcapReportGroupEnum.Pillar2:
                setItems(Pillar2_Items);
                break;
            default:
                break;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.search])

    return (
        <AppMainCard items={items}/>
    )
}

export default EcapModuleReportGroup